/////////////// LIB. ///////////////
////////////////////////////////////

// ...

////////////// UTIL. ///////////////
////////////////////////////////////

// ...

////////// EVENT HANDLERS //////////
////////////////////////////////////

// ...

////////////// ASSETS //////////////
////////////////////////////////////

const logArgs = { eventName: "init_flkty", inline: true, disabled: false };
const msgs = {
  start: ["init. flkty"],
  end: ["init. flkty", "init. success"],
  no_el: ["init. flkty", "no valid DOM el. provided"],
};

//////// INIT. METHOD DEF. /////////
////////////////////////////////////

export default function init_flkty() {
  ////////////// Setup ///////////////
  ////////////////////////////////////

  const { wrpr_slides, btn_prev, btn_next, dots } = this.ref;
  this.logger("init", msgs.start, "action", logArgs);

  // Guard //
  if (!this.validate_refEl(wrpr_slides)) return this.cancel_featInit(msgs.no_el);

  ////////////// ACTION //////////////
  ////////////////////////////////////

  const inst_flkty = new Flickity(wrpr_slides, {
    cellSelector: "[g-ref='slides']",
    wrapAround: true,
    // autoPlay: 5000,
    cellAlign: "center",
    contain: false,
    pageDots: false,
    prevNextButtons: false,
    selectedAttraction: 0.03,
    friction: 0.28,
    draggable: true,
    imagesLoaded: true,
    lazyLoad: 1,
    on: {
      //////// Ready /////////
      ////////////////////////

      // ready: () => {
      //   if (this.options.logs) console.log("Slider ready.");
      // },

      ///// Slide change /////
      ////////////////////////

      change: (index_activeSlide) => this.setState({ index_activeSlide }),
    },
  });

  if (btn_prev) btn_prev.addEventListener("click", () => inst_flkty.previous());
  if (btn_next) btn_next.addEventListener("click", () => inst_flkty.next());

  //////////// Dots init. ////////////
  ////////////////////////////////////

  if (dots && dots.length > 0) {
    dots.forEach((dot, i) => dot.addEventListener("click", () => inst_flkty.select(i)));
  }

  ///////////// Conclude /////////////
  ////////////////////////////////////

  this.modules.flkty.instance = inst_flkty;
  this.logger("init", msgs.end, "success", logArgs);
}

// ———————————————————————————————————————————————————————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //
